import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SecondPageEditBase } from '../../classes/base/second-page-edit-base';
import { ProvincesService } from '../../../dapfood/services/provinces.service';
import { DistrictsService } from '../../../dapfood/services/districts.service';
import { CustomerTypesService } from '../../../dapfood/services/customerTypes.service';
import { WardsService } from '../../../dapfood/services/wards.service';
import { UserService } from '../../services/user.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../../shared/utilities';
import { CustomerTypeOption, PositionType, UserType } from '../../../dapfood/common/constant';
import { UsersTempService } from '../../../dapfood/services/userstemp.service';
import { OrganizationsService } from '../../../dapfood/services/organizations.service';
import { ClientsService } from '../../../dapfood/services/clients.service';
import * as moment from 'moment';
import { DetailAddress } from '../../models/detailAddress.model';
import { DrugCategoriesService } from '../../../dapfood/services/drug-category.service';

@Component({
  selector: 'app-user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.scss']
})
export class UserInformationComponent extends SecondPageEditBase implements OnInit {
  formGroup: FormGroup;
  isShow = false;
  customerTypes_options: any = [];
  userGroups_options: any = [];
  organization_options: any = [];
  pharmacyType_options: any = [];
  tdvGroups_options = [];
  client_options = [];
  province_options: any = [];
  district_options: any = [];
  ward_options: any = [];
  placeOfIssueDkdn_options: any = [];
  isLoading = false;
  submitted = false;
  isEditCode: boolean = false;
  modelEdit: any = {
    userId: 0,
    name: "",
    idType: -1,
    checkDuplicate: true,
  };
  isCreate = false;
  userType = UserType;
  accountType_options = [];
  postionType_options = [];
  isShowAccountType = false;
  typeUser: number = -1;
  tdvGroups = [];
  isGetLocation: boolean = false;
  addressLatLng: string = "";
  @Input() isFormTdv = false;
  @Input() titleHeader: string = "Thêm/Sửa nhà thuốc";
  drugCategory: any[] = [];
  drugCategory_options: any[] = [];
  crrUser: any;
  showDrugCategoryPopup = false;
  drugCategoryFilter = '';
  drugCategory_filtered: any[] = [];

  constructor(
    protected _injector: Injector,
    private _ProvincesService: ProvincesService,
    private _DistrictsService: DistrictsService,
    private _customerTypesService: CustomerTypesService,
    private _WardsService: WardsService,
    private _UserService: UserService,
    private _UsersTempService: UsersTempService,
    private _configurationService: ConfigurationService,
    private _OrganizationService: OrganizationsService,
    private _drugCategoriesService: DrugCategoriesService,
    private _ClientService: ClientsService
  ) {
    super(null, _injector);

    this.formGroup = new FormGroup({
      isCompany: new FormControl(''),
      name: new FormControl('', Validators.compose([Validators.required, Validators.pattern(new RegExp('^[a-zA-Z0-9/&._\\- \\p{L}]*$', 'u'))])),
      phone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(8)])),
      password: new FormControl(''),  //, Validators.compose([Validators.required, Validators.minLength(6)])
      email: new FormControl(''),
      code: new FormControl(''),
      avatar: new FormControl(''),
      legalRepresentatives: new FormControl(''),
      pharmacistPtcm: new FormControl(''),
      idCardPtcm: new FormControl(''),
      phonePtcm: new FormControl(''),
      idProvince: new FormControl(''),
      idDistrict: new FormControl(''),
      idWard: new FormControl(''),
      address: new FormControl(''),
      fullAddress: new FormControl(''),
      certificateNumberDkdn: new FormControl(''),
      certificateDkdnDate: new FormControl(''),
      placeOfIssueDkdn: new FormControl(''),
      certificateDkdn: new FormControl(''),
      certificateNumberDdkkd: new FormControl(''),
      certificateDdkkdDate: new FormControl(''),
      placeOfIssueDdkkd: new FormControl(''),
      certificateDdkkd: new FormControl(''),
      certificateNumberGdpGppDsp: new FormControl(''),
      certificateGdpGppDspExpirationDate: new FormControl(''),
      certificateGdpGppDspDate: new FormControl(''),
      placeOfIssueGdpGppDsp: new FormControl(''),
      certificateGdpGppDsp: new FormControl(''),
      idPharmacyType: new FormControl('', Validators.compose([Validators.required])),
      invoiceCompanyName: new FormControl(''),
      invoiceEmail: new FormControl(''),
      invoiceTaxCode: new FormControl(''),  //, Validators.compose([Validators.required, Validators.pattern(/^.{10}$|^.{14}$/)])
      cccd: new FormControl(''),  //, Validators.compose([Validators.required, Validators.minLength(12), Validators.maxLength(12)])
      invoiceAddress: new FormControl(''),
      userCustomerTypes: new FormControl(''),
      userName: new FormControl(''),
      passwordRepeat: new FormControl(''),
      idCustomerType: new FormControl(''),
      idGroup: new FormControl(''),
      idType: new FormControl(''),
      lat: new FormControl(''),
      lng: new FormControl(''),
      idOrganization: new FormControl(''),
      isLeader: new FormControl(''),
      tdvGroups: new FormControl(''),
      idClient: new FormControl(''),
      idPosition: new FormControl(''),
      codeMapInvoice: new FormControl(''),
      certificateImages: new FormControl(''),
      drugCategory: new FormControl(''),
      checkDuplicate: new FormControl(true),
      call: new FormControl(),
      codeDap: new FormControl(''),
      salary: new FormControl(''),
      allowanceEat: new FormControl(''),
      allowanceGas: new FormControl(''),
      allowanceInternet: new FormControl(''),
      deduction: new FormControl(''),
      isNoSendZns: new FormControl(false),
      joinDate: new FormControl(''),
      endWorkDate: new FormControl(''),
      machineUserCode: new FormControl(''),
      userIdDss: new FormControl(''),
    });

  }

  async ngOnInit() {
    this.init();
  }

  async init() {
    this.vi = this._configurationService.calendarVietnamese;
    this.crrUser = await this._UserService.getCurrentUser();
    await this.loadUserTypes(); // Loại khách hàng
    await this.loadPharmacyTypes();
    await this.loadOrganization();
    await this.loadClient();
    await this.onLoadDrugCategories();
    await this.onloadPositionType();
    this.accountType_options = [
      { label: 'Loại tài khoản', value: -1 },
      { label: 'Khách hàng', value: UserType.NhaThuoc },
      { label: 'Nhân viên', value: UserType.TrinhDuocVien },
      { label: 'Doanh nghiệp', value: UserType.DoanhNghiep },
      { label: 'Kho', value: UserType.Kho },
    ]

    // this.postionType_options = [
    //   { label: 'Admin Mypha', value: PositionType.ChuSoHuu },
    //   { label: 'Quản lý (ASM/RSM)', value: PositionType.GiamSat },
    //   { label: 'SalesForce (Trình dược viên)', value: PositionType.NhanVien },
    //   { label: 'DVKH', value: PositionType.DVKH },
    //   { label: 'CSTDV', value: PositionType.CSTDV },
    //   { label: 'CSKH', value: PositionType.CSKH },
    //   { label: 'Kế toán', value: PositionType.KeToan },
    //   { label: 'NCC', value: PositionType.NCC },
    //   { label: 'Khác', value: PositionType.Other },
    // ]

  }

  async onLoadDrugCategories() {
    await this._drugCategoriesService.searchDropdown('').then(rs => {
      this.drugCategory_options = rs.data;
      this.drugCategory_filtered = rs.data;
    });
  }

  async onloadPositionType() {
    this.postionType_options = [];
    await this._UserService.GetShortPosition().then(rs => {
      if (rs.status) {
        rs.data.forEach(item => {
          this.postionType_options.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  onChangeDrugCategory(event) {
    if (this.drugCategory_options && this.drugCategory_options.length > 0) {
      var drug = this.drugCategory_options.find(d => d.value == event.itemValue);
      //   if (event.value.filter(d => d == event.itemValue).length > 0) {
      //     //thêm
      //     if (!drug.idParent || drug.idParent <= 0) {
      //       this.drugCategory_options.filter(d => d.idParent == drug.value).forEach(element => {
      //         this.drugCategory.push(element.value);
      //       });
      //     } else {
      //       if (this.drugCategory_options.filter(d => d.idParent == drug.idParent).length == this.drugCategory_options.filter(d => d.idParent == drug.idParent && this.drugCategory.includes(d.value)).length) {
      //         this.drugCategory.push(drug.idParent);
      //       }
      //     }
      //   } else {
      //     //bớt
      //     if (!drug.idParent || drug.idParent <= 0) {
      //       this.drugCategory_options.filter(d => d.idParent == drug.value).forEach(element => {
      //         this.drugCategory = this.drugCategory.filter(d => d != element.value);
      //       });
      //     }
      //     else {
      //       if (this.drugCategory_options.filter(d => d.idParent == drug.idParent).length !== this.drugCategory_options.filter(d => d.idParent == drug.idParent && this.drugCategory.includes(d.value)).length) {
      //         this.drugCategory = this.drugCategory.filter(d => d != drug.idParent);
      //       }
      //     }
      //   }
    }
  }

  async showPopup(data) {
    console.log(data);

    this.isEditCode = data.userId > 0 ? true : false;
    this.addressLatLng = '';
    this.modelEdit = {};
    this.isShow = true;
    this.submitted = false;
    this.modelEdit.idType = data.idType;
    this.typeUser = data.type;
    this.tdvGroups = [];
    this.drugCategory = [];
    this.isShowAccountType = data.isShowAccountType;

    await this.onLoadProvinces();

    if (data.userId > 0) {

      this.formGroup.get('password').clearValidators();
      this.formGroup.get('password').updateValueAndValidity();

      await this._UserService.GetByUserId(data.userId).then(async rs => {
        if (rs.status) {
          this.modelEdit = rs.data;
          if (this.modelEdit.certificateDkdnDate) {
            this.modelEdit.certificateDkdnDate = new Date(this.modelEdit.certificateDkdnDate);
          }
          if (this.modelEdit.certificateGdpGppDspDate) {
            this.modelEdit.certificateGdpGppDspDate = new Date(this.modelEdit.certificateGdpGppDspDate);
          }
          if (this.modelEdit.certificateGdpGppDspExpirationDate) {
            this.modelEdit.certificateGdpGppDspExpirationDate = new Date(this.modelEdit.certificateGdpGppDspExpirationDate);
          }
          if (this.modelEdit.certificateDdkkdDate) {
            this.modelEdit.certificateDdkkdDate = new Date(this.modelEdit.certificateDdkkdDate);
          }
          if (this.modelEdit.joinDate) {
            this.modelEdit.joinDate = new Date(this.modelEdit.joinDate);
          }
          if (this.modelEdit.endWorkDate) {
            this.modelEdit.endWorkDate = new Date(this.modelEdit.endWorkDate);
          }
        }
      }, () => {
        this._notifierService.showHttpUnknowError();
      });

      // if (data.tdvEditTemp != null && data.tdvEditTemp > 0) {
      //   this.formGroup.addControl('isEditTdvTemp ', new FormControl(data.tdvEditTemp));
      //   this.modelEdit.isEditTdvTemp = data.tdvEditTemp
      // }
      if (this.modelEdit.userOrganizations) {
        this.modelEdit.userOrganizations.forEach(element => {
          this.tdvGroups.push(Number(element.idOrganization));
        });
      }

      if (this.modelEdit.userDrugCategories) {
        this.modelEdit.userDrugCategories.forEach(element => {
          this.drugCategory.push(Number(element.idDrugCategories));
        });
      }

    } else {
      if (data.idType == UserType.TrinhDuocVien) {
        this.formGroup.get('password').setValidators([Validators.required, Validators.minLength(6)]);
        this.formGroup.get('password').updateValueAndValidity();
      }

      data.userId = 0;

      this.modelEdit = data;

      this.isCreate = true;
    }

    this.syncOrganizationSelectionState();

    if (this.modelEdit.idType === UserType.NhaThuoc) {
      this.formGroup.get('idPharmacyType').setValidators([Validators.required]);
    } else {
      this.formGroup.get('idPharmacyType').clearValidators();
    }
    this.formGroup.get('idPharmacyType').updateValueAndValidity();

    if (data.idType === -1 && data.userId <= 0) {
      this.formGroup.get('accountType').setValidators([Validators.required]);
      this.formGroup.get('accountType').updateValueAndValidity();
    }

    if (this.modelEdit.idType === UserType.NhaThuoc)
      await this.loadUserGroupsNT();

    this.onLoadDistricts();
    this.onLoadWards();
    this.fn_CheckLocationLatLng(this.modelEdit.lat, this.modelEdit.lng);
  }

  // Gọi lại hàm này mỗi khi modelEdit.isCompany thay đổi
  updateInvoiceTaxCodeValidator(): void {
    const controlinvoiceTaxCode = this.formGroup.get('invoiceTaxCode');
    const controlcccd = this.formGroup.get('cccd');

    if (!controlinvoiceTaxCode) return;
    if (!controlcccd) return;

    if (this.modelEdit.isCompany === undefined) {
      controlcccd.clearValidators();
      controlinvoiceTaxCode.clearValidators();
      return;
    }

    if (this.modelEdit.isCompany === true) {
      controlinvoiceTaxCode.setValidators([Validators.pattern(/^(\d{10}|\d{10}-\d{3})$/)]);
      controlcccd.clearValidators();
      // controlcccd.setValue('');
    } else {
      controlcccd.setValidators([Validators.pattern(/^\d{12}$/)]);
      controlinvoiceTaxCode.clearValidators();
      // controlinvoiceTaxCode.setValue('');
    }

    controlinvoiceTaxCode.updateValueAndValidity();
    controlcccd.updateValueAndValidity();
  }

  // cơ cấu tổ chức
  async loadOrganization() {
    this.organization_options = [];
    await this._OrganizationService.GetShort(
      '',
      0,
      10000,
      ''
    ).then(rs => {
      if (rs.status) {
        this.organization_options = rs.data || [];
        this.syncOrganizationSelectionState();
      }
    });
  }

  //loại khách hàng
  syncOrganizationSelectionState() {
    const selectedIds = (this.tdvGroups || []).map(id => Number(id));
    this.organization_options = (this.organization_options || []).map(item => {
      const newItem = Object.assign({}, item);
      newItem.checked = selectedIds.indexOf(Number(item.id)) >= 0;
      return newItem;
    });
  }

  onOrganizationSelectionChanged(items: any[]) {
    this.tdvGroups = (items || [])
      .filter(item => item && item.id !== undefined && item.id !== null)
      .map(item => Number(item.id));
    this.formGroup.get('tdvGroups').setValue(this.tdvGroups);
  }

  async loadUserTypes() {
    this.customerTypes_options = [];
    await this._customerTypesService.GetShort('', CustomerTypeOption.IdCustomerType, 0, 10000).then(rs => {
      if (rs.status) {
        let dataArr: any = [];
        rs.data.forEach(item => {
          dataArr.push({ label: item.name, value: item.id });
        });
        this.customerTypes_options = dataArr;
      }
    });
  }

  //loại hình nhà thuốc
  async loadPharmacyTypes() {
    this.pharmacyType_options = [];
    await this._customerTypesService.GetShort('', CustomerTypeOption.idPharmacyType, 0, 10000).then(rs => {
      if (rs.status) {
        rs.data.forEach(item => {
          this.pharmacyType_options.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  //doanh nghiệp
  async loadClient() {
    this.client_options = [];
    await this._ClientService.GetShort('').then(rs => {
      if (rs.status) {
        rs.data.forEach(item => {
          this.client_options.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  async onLoadDistricts() {
    await this._DistrictsService.GetShort(this.modelEdit.idProvince).then(rs => {
      if (rs.status) {
        this.district_options = rs.data;
      }
    });
  }

  async onLoadProvinces() {
    await this._ProvincesService.GetShort().then(rs => {
      if (rs.status) {
        this.province_options = rs.data;
        this.placeOfIssueDkdn_options = rs.data;
      }
    });
  }

  async onLoadWards() {
    await this._WardsService.GetShort(this.modelEdit.idDistrict).then(rs => {
      if (rs.status) {
        this.ward_options = rs.data;
      }
    });
  }

  onSwitchChange(isLeader: boolean) {
    this.modelEdit.isLeader = isLeader ? isLeader : false;
  }

  //nhóm khách hàng
  async loadUserGroupsNT() {
    await this._customerTypesService.GetShort('', CustomerTypeOption.IdGroupNT, 0, 10000).then(rs => {
      if (rs.status) {
        var list: any = [];
        rs.data.forEach(item => {
          list.push({ label: item.name, value: item.id });
        });
        this.userGroups_options = list;
      }
    });
  }
  //(ngModelChange)="onDateChange($event, 'certificateGdpGppDspExpirationDate')"
  onDateChange(value: any, field: string) {
    var newValue = value === null ? '' : value;
    this.modelEdit[field] = newValue;
    this.formGroup.get(field).setValue(newValue);
    console.log(this.modelEdit[field]);
  }

  save() {
    this.isLoading = true;
    this.submitted = true;
    this.modelEdit.userOrganizations = [];
    console.log(this.modelEdit);
    if (this.formGroup.valid) {
      this.modelEdit.username = this.modelEdit.phone; // this.f.userName.setValue(this.f.phone.value);
      this.modelEdit.passwordRepeat = this.modelEdit.password; //this.f.passwordRepeat.setValue(this.f.password.value);
      let _userCustomerTypes = [];
      this.modelEdit.userCustomerTypes = _userCustomerTypes; //this.f.userCustomerTypes.setValue(_userCustomerTypes);

      if (this.tdvGroups && this.tdvGroups.length > 0) {
        this.tdvGroups.forEach(g => {
          this.modelEdit.userOrganizations.push({ userId: this.modelEdit.userId, idOrganization: g });
        })
      }

      this.modelEdit.userDrugCategories = [];

      if (this.drugCategory) {
        this.drugCategory.forEach(element => {
          this.modelEdit.userDrugCategories.push({ idDrugCategories: element });
        });
      }

      if (this.modelEdit.certificateDkdnDate && moment(this.modelEdit.certificateDkdnDate).isValid()) {
        this.modelEdit.certificateDkdnDate = moment(this.modelEdit.certificateDkdnDate).format('YYYY-MM-DD HH:mm');
      }

      if (this.modelEdit.certificateDdkkdDate && moment(this.modelEdit.certificateDdkkdDate).isValid()) {
        this.modelEdit.certificateDdkkdDate = moment(this.modelEdit.certificateDdkkdDate).format('YYYY-MM-DD HH:mm');
      }

      if (this.modelEdit.certificateGdpGppDspDate && moment(this.modelEdit.certificateGdpGppDspDate).isValid()) {
        this.modelEdit.certificateGdpGppDspDate = moment(this.modelEdit.certificateGdpGppDspDate).format('YYYY-MM-DD HH:mm');
      }

      if (this.modelEdit.certificateGdpGppDspExpirationDate && moment(this.modelEdit.certificateGdpGppDspExpirationDate).isValid()) {
        this.modelEdit.certificateGdpGppDspExpirationDate = moment(this.modelEdit.certificateGdpGppDspExpirationDate).format('YYYY-MM-DD HH:mm');
      }

      if (this.modelEdit.joinDate && moment(this.modelEdit.joinDate).isValid()) {
        this.modelEdit.joinDate = moment(this.modelEdit.joinDate).format('YYYY-MM-DD HH:mm');
      }

      if (this.modelEdit.endWorkDate && moment(this.modelEdit.endWorkDate).isValid()) {
        this.modelEdit.endWorkDate = moment(this.modelEdit.endWorkDate).format('YYYY-MM-DD HH:mm');
      }

      console.log(" 333 ");
      console.log(this.modelEdit);

      this.modelEdit.checkDuplicate = (this.modelEdit.checkDuplicate != null) ? this.modelEdit.checkDuplicate : true;

      this._UserService.post(this.modelEdit).then(async (response) => {
        if (response.status) {
          if (response.data != null && response.data.userId > 0) {

            this.modelEdit.userId = response.data.userId;
            this.modelEdit.isDeleted = 0;

            this._notifierService.showSuccess(response.message);
            // if (this.isCreate) {
            //   await this._UserService.changeIdType(this.modelEdit.userId, this.modelEdit.idType).then(rs => {
            //     if (rs.status) {
            //       this._notifierService.showSuccess(rs.message);
            //     } else {
            //       this._notifierService.showError(rs.message);
            //     }
            //   })
            //     .catch(err => {
            //       this._notifierService.showWarning(Utilities.getErrorDescription(err));
            //     });
            // }
            this.closePopupMethod(response.data);
          }
        } else {

          // Nếu kiểm tra trùng giấy tờ thì sẽ không lưu và hiển thị cảnh báo và confirm có tiếp tục không
          if (response.data != null && response.data.checkDuplicate == false) {
            this._notifierService.showConfirm(response.message + `<br/><br/><b>Bạn có chắc chắn muốn tiếp tục không ? </b>`, 'Trùng thông tin').then(() => {
              this.modelEdit.checkDuplicate = false; // Đặt lại checkDuplicate để không kiểm tra trùng lặp nữa
              this.save(); // Gọi lại hàm save để lưu thông tin     
            });

            this.isLoading = false;
            return;
          }
          else
            this._notifierService.showError(response.message);
        }
      })
        .catch(error => {
          this.isLoading = false;
          this._notifierService.showWarning(Utilities.getErrorDescription(error));
        });
    }
    else {
      const invalid = this.findInvalidControls();
      this._notifierService.showError(invalid, 'Vui lòng nhập đủ thông tin');
    }

    this.isLoading = false;
  }

  findInvalidControls() {
    const controls = this.formGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        const ce = controls[name].errors;
        // if (ce.required) return `Vui lòng nhập ${this.getControlTitle(name)}`;
        // if (ce.minlength)
        //   return `${this.getControlTitle(name)} ít nhất ${ce.minlength.requiredLength} ký tự`;
        // if (ce.pattern) {
        //   if (name === 'invoiceTaxCode')
        //     return `${this.getControlTitle(name)} phải có độ dài 10 hoặc 14 ký tự`;
        //   if (name === 'cccd')
        //     return `${this.getControlTitle(name)} phải có độ dài 12 ký tự`;
        // }
        //if (ce.email) return `${this.getControlTitle(name)} sai định dạng`;
      }
    }
    return '';
  }

  closePopupMethod(data: any) {
    this.formGroup.reset();
    this.isShow = false;
    this.isGetLocation = false;
    this.closePopup.next(data);
  }

  getControlTitle(name) {
    switch (name) {
      case 'name':
        return 'Tên nhà thuốc/phòng khám/TDV';
      case 'phone':
        return 'Số điện thoại';
      case 'password':
        return 'Mật khẩu';
      //case 'email':
      //return 'Email';
      case 'idPharmacyType':
        return 'Loại tài khoản';
      case 'invoiceTaxCode':
        return 'mã số thuế';
      case 'cccd':
        return 'Số CCCD';
    }
  }

  accountTypeChange() {
    if (this.modelEdit.idType === UserType.NhaThuoc) {
      this.formGroup.get('idPharmacyType').setValidators([Validators.required]);
      this.loadUserGroupsNT();
    } else {
      this.formGroup.get('idPharmacyType').clearValidators();
    }
    this.formGroup.get('idPharmacyType').updateValueAndValidity();
  }

  buildTree(data: any, parentId = null) {
    const result = [];
    // Nếu parentId là null, ta sẽ tìm tất cả các mục có idParent là 0 (thằng cha to nhất)
    //const filteredData = parentId === null ? data.filter(item => item.idParent === 0) : data.filter(item => item.idParent === parentId);
    data
      .filter(item => item.idParent === parentId)
      .forEach(item => {
        const children = this.buildTree(data, item.id);
        const newNode = {
          idParent: item.idParent,
          id: item.id,
          name: item.name,
          checked: false,
          expanded: false,
          children: children.length ? children : undefined
        };
        result.push(newNode);
      });

    return result;
  }


  flattenTree(nodes: any[], level: number = 0): any[] {
    let result = [];
    nodes.forEach(node => {
      result.push({
        label: `${' _ '.repeat(level)} ${node.name}`,
        value: node.id
      });
      if (node.children) {
        result = result.concat(this.flattenTree(node.children, level + 1));
      }
    });
    return result;
  }

  viewLocation(lat: any, lng: any) {
    if (lat && lng) {
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, '_blank');
    } else {
      alert('Toạ độ không hợp lệ!!!.');
    }
  }

  fn_CheckLocationLatLng(lat: number, lng: number) {
    if (!lat || !lng) {
      this.addressLatLng = '';
      this.isGetLocation = false;
      return;
    }

    const getJsonLoccationLatLng = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&accept-language=vi`;
    fetch(getJsonLoccationLatLng)
      .then(response => response.json())
      .then(data => {
        const detailAddress: DetailAddress = this.mapJsonToDetailAddress(data);
        this.addressLatLng = detailAddress.display_name;
      })
      .catch(error => console.error("CHECK LẠI LAT LNG"));
    this.isGetLocation = !this.isGetLocation;
  }

  onAdminApprove(item: any, e) {
    this._UserService.Approved(item.userId, e.checked).then(rs => {
      if (rs.status) {
        this._notifierService.showSuccess('Kích hoạt thành công');
      } else {
        this._notifierService.showError(rs.message);
      }
    });
  }

  fillImage(event: any) {
    console.log(event);
    this.modelEdit.certificateDdkkd = event.certificateDdkkd;
    this.modelEdit.certificateGdpGppDsp = event.certificateGdpGppDsp;
    this.modelEdit.certificateDkdn = event.certificateDkdn;
  }

  removeDrugCategory(val: any) {
    this.drugCategory = this.drugCategory.filter(d => d !== val);
  }

  getDrugCategoryName(val: any): string {
    const option = this.drugCategory_options.find(o => o.value === val);
    if (!option) return '';
    // Bỏ prefix _ _ dùng để thụt lề cây danh mục
    return (option.label || '').replace(/^[\s_]+/, '').trim();
  }

  filterDrugCategories(keyword: string) {
    const kw = (keyword || '').toLowerCase().trim();
    this.drugCategory_filtered = kw
      ? this.drugCategory_options.filter(item => (item.label || '').toLowerCase().includes(kw))
      : this.drugCategory_options.slice();
  }

  toggleDrugCategory(val: any) {
    const idx = this.drugCategory.indexOf(val);
    if (idx !== -1) {
      this.drugCategory = this.drugCategory.filter(d => d !== val);
    } else {
      this.drugCategory = [...this.drugCategory, val];
    }
  }

}
